const SecurityHeaders = {headers:{'content-type':"multipart/form-data"}}
export default SecurityHeaders 